<template>
            <div v-if="brandLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
            <div v-if="brandError" class="mc-error">{{ brandError }}</div>
            <div v-if="brandLoaded" class="cr-catalog__brands">
              <div class="cr-form" method="get" autocomplete="off">
                <div class="cr-search-field">
                  <button class="cr-search-field__button" type="submit" aria-label="Найти">
                    <svg class="cr-search-field__button-icon" width="20" height="20" viewBox="0 0 20 20">
                      <use xlink:href="/assets/img/svg/sprite.svg#icon-search"></use>
                    </svg>
                  </button>
                  <input class="cr-search-field__input js-input-search" type="search" name="search" placeholder="Поиск по брендам" @input="doSearch" :value="searchQuery">
                  <button @click="clearSearch"
                  class="cr-search-field__button-delete js-button-delete" type="button">
                    <svg class="cr-search-field__icon-delete" width="20" height="20" viewBox="0 0 25 25">
                      <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-3"></use>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="cr-letter-index">
                <ul class="cr-letter-index__list">
                  <template v-for="item_letter in filteredBrands">
                  <li class="cr-letter-index__item" :id="'letter-'+item_letter.letter">
                    <div class="cr-letter-index__title">
                      {{item_letter.letter}}
                    </div>
                    <ul class="cr-letter-index__result-list">
                      <li v-for="item in item_letter.brands" class="cr-letter-index__result-item">
                        <div class="cr-category-card">
                          <div class="cr-category-card__body">
                            <router-link class="cr-category-card__title" :to="'/category/all/?set_filter=Y&'+item.param">
                              {{ item.name }}
                            </router-link>
                            <dl class="cr-category-card__list">
                              <router-link v-for="section in item.sections" class="cr-category-card__item" :to="'/category/'+section.id+'/?set_filter=Y&'+item.param">
                                <dt class="cr-category-card__term">
                                  {{ section.section }}
                                </dt>
                                <dd class="cr-category-card__value">
                                  {{ section.quantity }}
                                </dd>
                              </router-link>
                            </dl>
                          </div>
                          <img v-if="item.image" class="cr-category-card__image" :src="item.image" width="50" height="50" alt="">
                        </div>
                      </li>
                    </ul>
                  </li>
                  </template>
                </ul>
                <div class="cr-letter-index__letters">
                  <ul class="cr-letter-index__letters-list">
                    <li v-for="letter in filteredBrands" class="cr-letter-index__letters-item">
                      <a class="cr-letter-index__letters-link simulated-hover"  @click.prevent="scrollToSection(letter.letter)"
                      >
                        {{letter.letter}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({
    searchQuery: '',

  }),
  created() {
    this.fetchBrand();
  },
  computed: {
    ...mapGetters('brand', [
      'brand',
      'brandLoading',
      'brandError',
      'brandLoaded'
    ]),
    filteredBrands() {
      return this.filterBrands();
    }

  },
  mounted() {
    this.$nextTick(() => {
      if (document.querySelector('.cr-letter-index__letters-list')) {
        document.querySelector('.cr-letter-index__letters-list').addEventListener('touchmove', (e) => {
          e.stopPropagation();
        }, {passive: false});
      }
    });
  },
  components: {},
  methods: {
    ...mapActions('brand', [
      'fetchBrand'
    ]),
    doSearch(evt) {
      this.searchQuery = evt.target.value;
    },
    filterBrands() {
      if (!this.searchQuery) return this.brand;

      const result = {};

      for (const [letter, brands] of Object.entries(this.brand)) {
        const filteredBrands = brands.brands.filter(brand => {

              return brand.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            }
        );
        if (filteredBrands.length > 0) {
          if (!result[letter])
            result[letter] = {
              letter: letter,
              brands: []
            };
          result[letter].brands = filteredBrands;
        }
      }

      return result;
    },
    clearSearch() {
      this.searchQuery = '';
    },
    scrollToSection(letter) {
      const elementId = `letter-${letter}`;
      const element = document.getElementById(elementId);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },


  },
}
</script>

